import { ItemConfig } from './types'

const CM_PX = 78.7

const sizes = {
  S: 0.846,
  M: 0.897,
  L: 0.948,
  XL: 1,
}

export const TSHIRT_CONFIG: ItemConfig = {
  name: 'Printstar ヘビーウェイトTシャツ',
  vendor: 'トムス',
  vendor_code: '085-CVT',
  printable_sections: ['103', '105'],
  colors: [
    { name: 'ホワイト', hex: '#FFFFFF', system_id: '001' },
    { name: 'アイビーグリーン', hex: '#235549', system_id: '138' },
    { name: 'アイボリー', hex: '#f5efdf', system_id: '073' },
    { name: 'アクア', hex: '#7acecc', system_id: '095' },
    { name: 'アッシュ', hex: '#d5d6d8', system_id: '044' },
    { name: 'アーミーグリーン', hex: '#40412c', system_id: '037' },
    { name: 'イエロー', hex: '#f8e75e', system_id: '020' },
    { name: 'イタリアンレッド', hex: '#e1363b', system_id: '169' },
    { name: 'インディゴ', hex: '#16244e', system_id: '097' },
    { name: 'エメラルド', hex: '#154c51', system_id: '442' },
    { name: 'オリーブ', hex: '#686549', system_id: '128' },
    { name: 'オレンジ', hex: '#ef7d1c', system_id: '015' },
    { name: 'オートミール', hex: '#d2cbc2', system_id: '039' },
    { name: 'ガーネットレッド', hex: '#ad0d28', system_id: '035' },
    { name: 'グリーン', hex: '#0b9e63', system_id: '025' },
    { name: 'コーラルオレンジ', hex: '#f5b72d', system_id: '170' },
    { name: 'ゴールドイエロー', hex: '#f6c02e', system_id: '077' },
    { name: 'サックス', hex: '#5fa7d3', system_id: '033' },
    { name: 'サンセットオレンジ', hex: '#ff4500', system_id: '038' },
    { name: 'シルバーグレー', hex: '#cbc9c0', system_id: '153' },
    { name: 'シーブルー', hex: '#04c1e1', system_id: '199' },
    { name: 'ジャパンブルー', hex: '#152a8b', system_id: '171' },
    { name: 'スモークブラック', hex: '#1f2627', system_id: '233' },
    { name: 'ターコイズ', hex: '#08b6d5', system_id: '034' },
    { name: 'チャコール', hex: '#575358', system_id: '129' },
    { name: 'チョコレート', hex: '#352827', system_id: '168' },
    { name: 'ディープオレンジ', hex: '#e62826', system_id: '192' },
    { name: 'ディープグリーン', hex: '#0f7c57', system_id: '193' },
    { name: 'ディープパープル', hex: '#342d48', system_id: '200' },
    { name: 'デイジー', hex: '#f8e51b', system_id: '165' },
    { name: 'デニム', hex: '#526064', system_id: '109' },
    { name: 'ナチュラル', hex: '#efdfc1', system_id: '106' },
    { name: 'ネイビー', hex: '#17242f', system_id: '031' },
    { name: 'バーガンディ', hex: '#9b3d42', system_id: '112' },
    { name: 'パープル', hex: '#7642b1', system_id: '014' },
    { name: 'ピンク', hex: '#eeabca', system_id: '011' },
    { name: 'ピーコックグリーン', hex: '#109791', system_id: '197' },
    { name: 'ピーチ', hex: '#eebfd3', system_id: '191' },
    { name: 'フォレスト', hex: '#395948', system_id: '131' },
    { name: 'ブライトグリーン', hex: '#32c567', system_id: '194' },
    { name: 'ブラック', hex: '#111011', system_id: '005' },
    { name: 'ホットピンク', hex: '#cf247f', system_id: '146' },
    { name: 'ホワイト×ネイビー', hex: '#191970', system_id: '731' },
    { name: 'ホワイト×ブラック', hex: '#70105', system_id: '705' },
    { name: 'ホワイト×レッド', hex: '#ff0000', system_id: '710' },
    { name: 'マスタード', hex: '#f4b714', system_id: '021' },
    { name: 'ミディアムブルー', hex: '#1982c7', system_id: '198' },
    { name: 'ミント', hex: '#0cc4c0', system_id: '196' },
    { name: 'ミントグリーン', hex: '#5ec2a8', system_id: '026' },
    { name: 'メトロブルー', hex: '#1d3450', system_id: '167' },
    { name: 'ライトイエロー', hex: '#f7e8a7', system_id: '134' },
    { name: 'ライトオレンジ', hex: '#f6bc90', system_id: '189' },
    { name: 'ライトグリーン', hex: '#c7da5c', system_id: '024' },
    { name: 'ライトサーモン', hex: '#ee8774', system_id: '190' },
    { name: 'ライトパープル', hex: '#c8adcf', system_id: '188' },
    { name: 'ライトピンク', hex: '#f9e1e1', system_id: '132' },
    { name: 'ライトブルー', hex: '#b3daeb', system_id: '133' },
    { name: 'ライム', hex: '#a3cd72', system_id: '155' },
    { name: 'ラベンダー', hex: '#c585c9', system_id: '019' },
    { name: 'レッド', hex: '#e22038', system_id: '010' },
    { name: 'ロイヤルブルー', hex: '#0c4aaf', system_id: '032' },
    { name: '杢グレー', hex: '#b2b2b2', system_id: '003' },
  ],
  sizes: ['S', 'M', 'L', 'XL'],
  sections: [
    {
      name: '胸中央',
      id: '103',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '左胸',
      id: '101',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右胸',
      id: '102',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '背中中央',
      id: '105',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '襟下',
      id: '109',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '左袖',
      id: '107',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右袖',
      id: '108',
      config: {
        width: 787,
        height: 787,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: 7000,
      height: 7000,
      origin: { x: 7000 / 2, y: 7000 * 0.19 },
      sizes: sizes,
      sections: [
        {
          id: '103',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '101',
          offset: {
            x: 5 * CM_PX,
            y: 6 * CM_PX,
          },
        },
        {
          id: '102',
          offset: {
            y: 6 * CM_PX,
            x: -(5 * CM_PX + 787),
          },
        },
      ],
    },
    {
      name: 'back',
      width: 7000,
      height: 7000,
      origin: { x: 7000 / 2, y: 7000 * 0.19 },
      sizes: sizes,
      sections: [
        {
          id: '105',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '109',
          offset: {
            x: -(787 / 2),
            y: 2.5 * CM_PX,
          },
        },
      ],
    },
    {
      name: 'left',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3494 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '107',
          offset: {
            y: -(2 * CM_PX + 787),
            x: -(787 / 2),
          },
        },
      ],
    },
    {
      name: 'right',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3494 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '108',
          offset: { y: -(2 * CM_PX + 787), x: -(787 / 2) },
        },
      ],
    },
  ],
}
